export default __webpack_public_path__ + "static/sqa-90b815ef5abee4e196176399c492517d.svg";